import {
  FETCH_OFFER_REQUEST,
  FETCH_OFFER_SUCCESS,
  SET_DEFAULT_FIELD_VALUES,
} from 'constants/index';
import { batch } from 'react-redux';
import {
  getCurrentCountryCode,
  getCurrentLocale,
  getRecipientId,
} from 'selectors';

export const fetchOffer =
  id =>
  async (dispatch, getState, { offer }) => {
    dispatch({ type: FETCH_OFFER_REQUEST });

    const state = getState();
    const recipientId = getRecipientId(state);
    const country = getCurrentCountryCode(state);
    const locale = getCurrentLocale(state);
    const response = await offer.fetch({
      id,
      recipientId,
      country,
      locale,
    });

    return batch(() => {
      dispatch({
        type: SET_DEFAULT_FIELD_VALUES,
        payload: response,
      });

      dispatch({ type: FETCH_OFFER_SUCCESS, payload: response });
    });
  };
